import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { useState, useEffect, Fragment } from 'react'
import {
  SurveyEngine_Models_SessionCollection,
  SurveyEngine_Models_Session,
  SurveyEngine_Models_SESurveyConfirmOperation,
  SurveyEngine_Models_RecruitResponse,
} from '../../../api'
import { Switch } from '@progress/kendo-react-inputs'
import { Error } from '@progress/kendo-react-labels'
import SessionStandby from '../../atoms/SessionStandby/SessionStandby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCalendarRange,
  faDiagramNested,
  faCalendarClock,
  faSquareInfo,
  faCalendarLines,
  faCircleExclamation,
  faCircleCalendar,
  faClock,
} from '@fortawesome/pro-regular-svg-icons'
import {
  useRecruitCtx,
  useRecruitDispatchCtx,
} from '../../../Context/RecruitContext'
import { ScheduleState, SelectedSession } from '../../../Common'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import { Button } from '@progress/kendo-react-buttons'
import {
  useSurveyCtx,
  useSurveyCtxDispatch,
} from '../../../Context/SurveyContext'
import parse from 'html-react-parser'

interface BasicSessionProps {
  id: number
  message: string
  studyName: string
  sessions: SurveyEngine_Models_SessionCollection
  panelistTimeZone: string
  isAcquireAvalibility: boolean
  postSurvey: boolean
  getSubmitPendingConfirmation?: (
    surveySID: string,
    payLoad: SurveyEngine_Models_RecruitResponse,
    operation: SurveyEngine_Models_SESurveyConfirmOperation
  ) => void
}
interface SessionTime {
  sessionid: number
  startTime: string
  endTime: string
  name: string
  isOverflow: boolean
  subSessions: Array<SurveyEngine_Models_Session>
}
interface SessionDay {
  day: string
  date: Date
  sesions: SessionTime[]
}
export const BasicSession = (props: BasicSessionProps) => {
  const recruitCtx = useRecruitCtx()
  const [groupedSessions, setGroupedSessions] = useState<Array<SessionDay>>()
  const [selectedSessionIDs, setSelectedSessionIDs] = useState<
    Array<SelectedSession>
  >(recruitCtx?.selectedSessions ?? [])

  const surveyCtxDispatch = useSurveyCtxDispatch()
  const recruitCtxDispatch = useRecruitDispatchCtx()
  const globalCtx = useGlobalCtx()
  const surveyCtx = useSurveyCtx()

  const [isError, setIsError] = useState(false)
  const [touched, setTouched] = useState(false)

  const switchRef = (node: HTMLInputElement) => {
    if (node) {
      node.focus()
    }
  }

  useEffect(() => {
    setSelectedSessionIDs(recruitCtx.selectedSessions)
  }, [recruitCtx.selectedSessions])

  useEffect(() => {
    let groupbyDay: SessionDay[] = []
    props.sessions.sessions?.forEach(
      (session: SurveyEngine_Models_Session, index: number) => {
        const start = new Date(session.startTime!)
        const end = new Date(session.endTime!)
        let day = formatInTimeZone(
          start,
          props.panelistTimeZone,
          'EEEE, MMMM dd, yyyy'
        )
        let startTime = String(
          formatInTimeZone(start, props.panelistTimeZone, 'h:mm aaa')
        ).toUpperCase()
        let endTime = String(
          formatInTimeZone(end, props.panelistTimeZone, 'h:mm aaa')
        ).toUpperCase()

        let gsIndex = groupbyDay.findIndex((ds) => ds.day === day)
        if (gsIndex !== -1) {
          groupbyDay[gsIndex].sesions.push({
            sessionid: session.id!,
            startTime: startTime,
            endTime: endTime,
            name: session.name!,
            isOverflow: session.isOverFlow!,
            subSessions: session.sessions ?? [],
          })
        } else {
          let sessionTime: SessionTime[] = [
            {
              sessionid: session.id!,
              startTime: startTime,
              endTime: endTime,
              name: session.name!,
              isOverflow: session.isOverFlow!,
              subSessions: session.sessions ?? [],
            },
          ]
          start.setHours(0, 0, 0)
          groupbyDay.push({ day: day, date: start, sesions: sessionTime })
        }
      }
    )
    groupbyDay.sort((left: SessionDay, right: SessionDay) => {
      if (left.date < right.date) {
        return -1
      } else if (left.date > right.date) {
        return 1
      } else {
        return 0
      }
    })
    setGroupedSessions(groupbyDay)
  }, [props])

  const onDecline = () => {
    recruitCtxDispatch({ type: 'ScheduleState', value: ScheduleState.DECLINE })
  }

  const onSkip = () => {
    //window.open(globalCtx.RedirectUrl, '_parent')
    window.location.href = globalCtx.RedirectUrl
  }
  const onReschedule = () => {
    if (selectedSessionIDs.length <= 0) {
      setIsError(true)
      window.scrollTo(0, 0)
    } else {
      recruitCtxDispatch({
        type: 'BasicSessionSelection',
        value: selectedSessionIDs,
      })
      surveyCtxDispatch({ type: 'clearAPIError', value: {} })
      recruitCtxDispatch({
        type: 'ScheduleState',
        value: ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM,
      })
    }
  }
  const onSchedule = () => {
    if (selectedSessionIDs.length <= 0) {
      setIsError(true)
      window.scrollTo(0, 0)
    } else {
      recruitCtxDispatch({
        type: 'BasicSessionSelection',
        value: selectedSessionIDs,
      })
      var res: SurveyEngine_Models_RecruitResponse = {
        commandIndex: props.id,
        commandType: 'Recruit',
        declined: false,
        eventUrl: '',
        inviteeUrl: '',
        sessionIds: selectedSessionIDs.map((item: SelectedSession) => {
          return item.sessionId
        }),
      }
      if (props.getSubmitPendingConfirmation) {
        props.getSubmitPendingConfirmation(
          surveyCtx.StartSurvey.surveyInstanceId!,
          res,
          SurveyEngine_Models_SESurveyConfirmOperation.PENDING_CONFIRMATION
        )
        //recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.CONFIRM });
      } else {
        console.log('getSubmitPendingConfirmation is null')
      }
    }
  }
  const sessionSelection = (
    sessionDay: string,
    selectedsession: SessionTime
  ) => {
    let currentSelectedSessionIDs = props.isAcquireAvalibility
      ? [...selectedSessionIDs]
      : []
    let currentIndex = currentSelectedSessionIDs.findIndex(
      (item) => item.sessionId === selectedsession.sessionid
    )
    if (currentIndex !== -1 && props.isAcquireAvalibility) {
      //session is already selected so unselect it
      currentSelectedSessionIDs.splice(currentIndex, 1)
    } else {
      let subsession = selectedsession.subSessions.map(
        (subsession: SurveyEngine_Models_Session) => {
          let sub: SelectedSession = {
            sessionId: subsession.id!,
            sessionName: 'SubSession',
            sessionDay: format(
              new Date(subsession.startTime!),
              'EEEE, MMMM dd, yyyy'
            ),
            sessionStartTime: String(
              formatInTimeZone(
                new Date(subsession.startTime!),
                props.panelistTimeZone,
                'h:mm aaa'
              )
            ).toUpperCase(),
            sessionEndTime: String(
              formatInTimeZone(
                new Date(subsession.endTime!),
                props.panelistTimeZone,
                'h:mm aaa'
              )
            ).toUpperCase(),
            isOverFlow: subsession.isOverFlow!,
            subSession: [],
          }
          return sub
        }
      )

      currentSelectedSessionIDs.push({
        sessionId: selectedsession.sessionid,
        sessionName: selectedsession.name,
        sessionDay: sessionDay,
        sessionStartTime: selectedsession.startTime,
        sessionEndTime: selectedsession.endTime,
        isOverFlow: selectedsession.isOverflow,
        subSession: subsession ?? [],
      })
    }

    setSelectedSessionIDs([...currentSelectedSessionIDs])
    setTouched(true)
    setIsError(false)
  }
  const displaySubSessions = (sessions: any, index: number) => {
    return (
      <div className="flex flex-col">
        <div
          id={`subSessionMsg_${index}`}
          className="theme-session-subsession pl-[5.5rem] pb-2 flex w-full"
        >
          <FontAwesomeIcon
            className="theme-session-subsession-icon theme-icon-spacer"
            icon={faDiagramNested}
          />
          <div className="theme-session-subsession-text text-sm pt-[3px] font-semibold">
            {globalCtx.LangResources.recruitMsg.subSessionMessage}
          </div>
        </div>
        <div
          id={`subSession_${index}`}
          className="theme-session-subsession pl-[5.5rem] pb-4"
        >
          {sessions.map((subSession: any, index: number) => {
            const start = new Date(subSession.startTime)
            const end = new Date(subSession.endTime)

            let day = format(start, 'EEEE, MMMM dd, yyyy')

            let time = String(
              formatInTimeZone(start, props.panelistTimeZone, 'h:mm aaa')
            ).toUpperCase()

            let endTime = String(
              formatInTimeZone(end, props.panelistTimeZone, 'h:mm aaa')
            ).toUpperCase()
            return (
              <div
                key={index}
                className="theme-session-subsession-date-time flex flex-col mx-5"
              >
                <div className="flex sm:flex-row flex-col justify-start py-2">
                  <div className="basis-1/2 align-middle font-semibold">
                    <FontAwesomeIcon
                      className="theme-session-subsession-date-time-icon theme-icon-spacer"
                      icon={faCircleCalendar}
                    />
                    <span className="font-medium text-sm">{day}</span>
                  </div>
                  <div className="basis-1/2 align-middle">
                    <FontAwesomeIcon
                      className="theme-session-subsession-date-time-icon theme-icon-spacer"
                      icon={faClock}
                    />
                    <span className="font-medium text-sm">
                      {time} to {endTime}
                    </span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div className="theme-session w-full">
      <div className="flex flex-col mb-4">
        <div className="theme-session-header w-full block">
          <FontAwesomeIcon
            icon={faCalendarClock}
            className="theme-session-header-icon"
          />
          <span
            id={`sessionHeader_${props.id}`}
            className="theme-session-header-text ml-2 text-3xl font-regular"
          >
            {globalCtx.LangResources.recruitMsg.selection.heading}
          </span>
        </div>
      </div>

      <div className="theme-session-info flex flex-col mb-4">
        <div
          id={`studyName_${props.id}`}
          className="text-base font-semibold pb-2"
        >
          <FontAwesomeIcon
            icon={faCalendarLines}
            className="theme-icon-spacer"
          />
          {globalCtx.LangResources.recruitMsg.studyMsg.replace(
            '{StudyName}',
            props.studyName
          )}
        </div>
        <div id={`msg_${props.id}`} className="text-base font-semibold pb-2">
          <FontAwesomeIcon icon={faSquareInfo} className="theme-icon-spacer" />
          <span className="theme-session-message">
            {parse(props.message.replace(/""/g, '"'))}
          </span>
        </div>
        {isError && (
          <Error
            className="theme-validator-error-text font-semibold"
            direction="start"
          >
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="theme-icon-spacer"
            />
            {globalCtx.LangResources.recruitMsg.basicSessionErrorMsg}
          </Error>
        )}
      </div>

      <div className="flex flex-col mb-4 md:min-h-96">
        {groupedSessions?.map((sessionDay: SessionDay, dayIndex: number) => {
          {
            console.log(sessionDay.day)
          }
          return (
            <div key={dayIndex} className="py-3">
              <div className="theme-session-subheader">
                <h2
                  id={`day_${dayIndex}`}
                  className="text-lg font-semibold mb-4"
                >
                  <FontAwesomeIcon icon={faCalendarRange} />
                  <span className="pl-2 lg:text-lg md:text-base text-xs font-semibold">
                    {sessionDay.day}
                  </span>
                </h2>
              </div>
              <fieldset className="theme-session-time">
                {sessionDay.sesions.map(
                  (sessionTime: SessionTime, timeIndex: number) => {
                    return (
                      <Fragment key={timeIndex}>
                        <div className="theme-session-group block w-full mb-4">
                          <div className="w-full">
                            {sessionTime.isOverflow && (
                              <SessionStandby
                                id={`StandBY_${sessionTime.sessionid}`}
                              />
                            )}
                          </div>

                          <div
                            className=" flex flex-row p-3"
                            data-index={sessionTime.sessionid}
                          >
                            <div className="theme-session-switch align-top m-1">
                              {dayIndex === 0 && timeIndex === 0 ? (
                                <Switch
                                  size="small"
                                  name={`session_${props.id}`}
                                  ref={
                                    (!touched &&
                                      selectedSessionIDs.length === 0) ||
                                    (!props.isAcquireAvalibility &&
                                      selectedSessionIDs.findIndex(
                                        (item) =>
                                          item.sessionId ===
                                          sessionTime.sessionid
                                      ) !== -1) ||
                                    (props.isAcquireAvalibility &&
                                      !touched &&
                                      selectedSessionIDs.findIndex(
                                        (item) =>
                                          item.sessionId ===
                                          sessionTime.sessionid
                                      ) !== -1)
                                      ? switchRef
                                      : undefined
                                  }
                                  key={sessionTime.sessionid}
                                  id={sessionTime.sessionid.toString()}
                                  ariaLabelledBy={`sessionHeader_${props.id} studyName_${props.id} msg_${props.id} day_${dayIndex} time_${sessionTime.sessionid} session_${sessionTime.sessionid} StandBY_${sessionTime.sessionid}  subSessionMsg_${sessionTime.sessionid} subSession_${sessionTime.sessionid}`}
                                  onLabel=""
                                  offLabel=""
                                  onChange={() => {
                                    sessionSelection(
                                      sessionDay.day,
                                      sessionTime
                                    )
                                  }}
                                  checked={
                                    selectedSessionIDs.findIndex(
                                      (item) =>
                                        item.sessionId === sessionTime.sessionid
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                />
                              ) : (
                                <Switch
                                  size="small"
                                  name={`${props.id}_session`}
                                  ref={
                                    (!props.isAcquireAvalibility &&
                                      selectedSessionIDs.findIndex(
                                        (item) =>
                                          item.sessionId ===
                                          sessionTime.sessionid
                                      ) !== -1) ||
                                    (props.isAcquireAvalibility &&
                                      !touched &&
                                      selectedSessionIDs.findIndex(
                                        (item) =>
                                          item.sessionId ===
                                          sessionTime.sessionid
                                      ) !== -1)
                                      ? switchRef
                                      : undefined
                                  }
                                  key={sessionTime.sessionid}
                                  id={sessionTime.sessionid.toString()}
                                  ariaLabelledBy={`day_${dayIndex} time_${sessionTime.sessionid} session_${sessionTime.sessionid} StandBY_${sessionTime.sessionid} subSession_${sessionTime.sessionid}`}
                                  onLabel=""
                                  offLabel=""
                                  onChange={() => {
                                    sessionSelection(
                                      sessionDay.day,
                                      sessionTime
                                    )
                                  }}
                                  checked={
                                    selectedSessionIDs.findIndex(
                                      (item) =>
                                        item.sessionId === sessionTime.sessionid
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                />
                              )}
                            </div>

                            <div className="theme-session-info min-w-max">
                              <div
                                id={`time_${sessionTime.sessionid}`}
                                className="font-semibold align-top lg:text-lg md:text-base text-xs ml-4 w-full text-left"
                              >
                                {sessionTime.startTime} to {sessionTime.endTime}
                              </div>
                              <div
                                id={`session_${sessionTime.sessionid}`}
                                className="font-normal ml-4 w-full text-left"
                              >
                                {sessionTime.name}
                              </div>
                            </div>
                          </div>

                          {sessionTime.subSessions?.length > 0 &&
                            displaySubSessions(
                              sessionTime.subSessions,
                              sessionTime.sessionid
                            )}
                        </div>
                      </Fragment>
                    )
                  }
                )}
              </fieldset>
            </div>
          )
        })}
      </div>
      {!props.postSurvey && (
        <div
          className={
            'theme-btn-container min-h-[5vh] block md:flex flex-row-reverse justify-between content-center pt-8 pb-2 mt-8'
          }
        >
          <div className="md:flex-row ">
            <Button
              className="theme-btn-schedule w-full md:w-auto"
              data-testid="schedule-button"
              onClick={onSchedule}
            >
              {globalCtx.LangResources.recruitMsg.scheduleButton}
            </Button>
          </div>
          <div className="my-2 md:flex-row md:my-0">
            <Button
              className="theme-btn-decline w-full md:w-auto"
              data-testid="decline-button"
              onClick={onDecline}
            >
              {globalCtx.LangResources.recruitMsg.declineButton}
            </Button>
          </div>
        </div>
      )}
      {props.postSurvey && (
        <div
          className={
            'theme-btn-container min-h-[5vh] md:flex flex-row-reverse justify-between pt-8 pb-2 mt-8'
          }
        >
          <div className="md:basis-1 lg:basis-1/3 lg:px-4">
            <div className="flex flex-col">
              <Button
                id="continueButton"
                className="theme-btn-reschedule w-full"
                data-testid="rescheduleContinue-button"
                onClick={onReschedule}
                aria-labelledby="continueMsg continueButton"
              >
                {globalCtx.LangResources.recruitMsg.rescheduleContinueButton ??
                  'Continue'}
              </Button>
              <div id="continueMsg" className="text-center text-sm pt-2">
                {globalCtx.LangResources.recruitMsg.rescheduleContinueButtonMsg}
              </div>
            </div>
          </div>
          <div className="md:basis-1 lg:basis-1/3 lg:px-4">
            <div className="flex flex-col">
              <Button
                id="skipButton"
                className="theme-btn-skip w-full"
                data-testid="skip-button"
                onClick={onSkip}
                aria-labelledby="skipMsg skipButton"
              >
                {globalCtx.LangResources.recruitMsg.skipButton ?? 'Skip'}
              </Button>
              <div id="skipMsg" className="text-center text-sm pt-2">
                {globalCtx.LangResources.recruitMsg.skipButtonMsg}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
